import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import * as tmi from "@/constants";

import {
    bonusReportKey,
    modelPortfolioKey,
    psProductKey,
    tradeAlertKey,
    psLessonsKey,
    webinarKey,
    openedPositionKey,
    openPositionsTitle,
    closedPositionKey,
    closedPositionsTitle,
    symbolColumnKey,
    stanceColumnKey,
    sectorColumnKey,
    lastCloseColumnKey,
    bpiStatusColumnKey,
    sectorRelativeStrengthColumnKey,
    peerRelativeStrengthColumnKey,
    marketRelativeStrengthColumnKey,
    initiatedColumnKey,
    actionsColumnKey,
    closedColumnKey,
    initiatedKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: psProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                stanceColumnKey,
                sectorColumnKey,
                lastCloseColumnKey,
                bpiStatusColumnKey,
                sectorRelativeStrengthColumnKey,
                peerRelativeStrengthColumnKey,
                marketRelativeStrengthColumnKey,
                initiatedColumnKey,
                actionsColumnKey
            ]
        },
        {
            key: closedPositionKey,
            title: closedPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                sectorColumnKey,
                initiatedColumnKey,
                closedColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    webinarKey,
    tmi.SpreadCalculatorKey,
    psLessonsKey
];

export function useProfitSkimmer() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( psProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'PS', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
